import { flags$ } from '@op/services'
import { createSelector } from '@reduxjs/toolkit'
import { currentLang$ } from './language'

export const canShowOnboarding$ = /*@__PURE__*/ createSelector(
	flags$,
	currentLang$,
	(flags, lang) =>
		!!(flags?.onboarding_wizard_enabled && flags?.onboarding_wizard_locales?.includes(lang)),
)
